import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Track page view in Google Analytics
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-47HQX87F36", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}
